import { ReviewAI } from "../../../lib/reviewApi";
import ReviewInputCN from "./ReviewInputCN";
import ReviewResultCN from "./ReviewResultCN";
import { useState, useCallback } from "react";

export default function ReviewPageCN() {
  const [text, setText] = useState("");
  const [answer, setAnswer] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // CN 페이지는 고정
  const lang = "zh-CN";

  const handleGenerate = useCallback(async () => {
    if (!text.trim()) {
      alert("请粘贴患者的评论文本。");
      return;
    }
    setLoading(true);
    setError("");
    setAnswer("");

    try {
      const res = await ReviewAI.reply({ text, tone: "warm", lang });
      setAnswer(res.answer);
      try {
        localStorage.setItem("review:lastText", text);
        localStorage.setItem("review:lastAnswer", res.answer);
      } catch {}
    } catch (e) {
      setError(e?.message || "生成失败");
    } finally {
      setLoading(false);
    }
  }, [text]);

  const handleCopy = useCallback(async () => {
    const toCopy = answer || "";
    if (!toCopy) return;
    try {
      await navigator.clipboard.writeText(toCopy);
      alert("已复制到剪贴板。");
    } catch {
      const el = document.createElement("textarea");
      el.value = toCopy;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      alert("已复制到剪贴板。");
    }
  }, [answer]);

  return (
    <section>
      <div id="content_title">
        <h2>AI 评论回复助手</h2>
        <p>请真诚回复患者的评论。AI 将理解评论的语气并为您生成一份温暖的回复草稿。</p>
      </div>

      <div className="content">
        <div>
          <ReviewInputCN
            value={text}
            onChange={setText}
            onSubmit={handleGenerate}
            loading={loading}
          />
          <ReviewResultCN
            answer={answer}
            error={error}
            loading={loading}
            onCopy={handleCopy}
          />
        </div>
      </div>
    </section>
  );
}
